// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vK-z","carousel":"wK-z"};